goog.provide('el8.appchart.dialog.chartFiler');

goog.require('el8.app.shared.dialog.filerFields');
goog.require('el8.template.appchart.dialog.chartFiler');
goog.require('el8.template.render.docMgr.filer');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.amplitude.documentHelpers');


/**
 * A dialog presenting similar options to the DocMgr Filer
 * for deciding what to do with a user-provided file
 */
el8.appchart.dialog.chartFiler = (function() {

    var documentTypes = null;

    var browserFileObj = null;
    var callbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'File Document into Chart',
        height: 400,
        width: 520,
        autoHeight: true,
        contentFn: function() {
            return el8.template.appchart.dialog.chartFiler.content({
                documentTypes: documentTypes,
                fromChart: true
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: el8.app.shared.dialog.filerFields.getSharedFields(false, _.bind(that.getForm, that)),
        validationOpts: el8.util.validate.standardOpts
    });

    form.addButton('save', 'Upload File', uploadFn, true);
    form.addCancelButton(function() { that.hide(); });
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        $.el8_ajax({
            type: 'GET',
            async: false,
            url: el8.service.urls.get('fileFormMetadata'),
            success: function(data) {
                documentTypes = data['available_document_types'];
                super_init.call(that);
            }
        });

        el8.app.shared.dialog.filerFields.addDocumentTypeListener(that.getContentElt(),
                                                                  _.bind(that.getForm, that),
                                                                  function() { return {'id': el8.ptdata.currPatient.getId()}; });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        browserFileObj = spec.file;
        callbackFn = spec.callbackFn || null;

        if (el8.data.currUser.isPhysician()) {
            form.setMindreaderItem('physicianUserName', el8.data.currUser.asSoyMap());
        }
        $('.file-name', that.getContentElt()).text(browserFileObj.name);
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        $('.file-name', that.getContentElt()).text('');
        el8.app.shared.dialog.filerFields.resetVisibleFields(form);
        browserFileObj = null;
        callbackFn = null;
    };

    function uploadFn() {
        if (!form.isValid()) { return; }
        el8.appservice.notifier.notify('Processing file... ' +
            'Please do not delete from your computer until it completes.', 30*1000);

        var map = form.getMapped(true, true);
        var reviewUserItem = this._form.getMindreaderItem('physicianUserName');
        map['review_user_id'] = reviewUserItem ? reviewUserItem.id : null;
        delete map['physician_user_name'];

        // Save at 00:00:00 time, unless we're today.
        var documentDate = el8.service.tz.newTzDate(map['document_date']);
        map['document_date'] = el8.service.tz.asServerFormatDateTime(el8.service.tz.zeroTimeIfNotToday(documentDate));

        var fd = new FormData();
        fd.append('file', browserFileObj);
        fd.append('params', JSON.stringify(map));

        var start = new Date();

        var _cb = function (data) {
            // Need to update the order (but not fulfill it, since that's already done in the view)
            el8.ptdata.refreshDocById(map.order_to_link*1);
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();

            if (map.is_signed_off && data && data.report) {
                // if the report is uploaded with "File on behalf of Reviewer" selected,
                // the new report will not be fetched by el8.appchart.mainFeeds.reqAct.update() above
                // need to explicitly fetch the report and refresh the report dialog
                // see https://app.asana.com/0/54647631195681/289210637140679
                el8.ptdata.fetchById(data.report.id);
                el8.appchart.dialog.reports.ensureRefreshAllAffected([data.report.id]);
            }

            if (callbackFn) { callbackFn(); }

            el8.util.amplitude.logFileDocument('patient chart', map, start);

            // Commenting out until we can get our mobile app to also add this
            // user property
            // el8.util.amplitude.addUserProperty('number of documents uploaded', 1);
        };

        $.el8_longPoll({
            url: el8.service.urls.get('uploadDocument'),
            data: fd,
            isFileUpload: true,
            success: _cb,
            error: function(data) {
                el8.appservice.notifier.clear();
            }
        });
        that.hide();
    }

    return that;

})();
